var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('header',{attrs:{"id":"header"}},[_c('nav',{staticClass:"left"},[_c('router-link',{staticClass:"logo",attrs:{"to":"/"}},[_vm._v("Server Corp")])],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('head',[_c('title',[_vm._v("Server Corp.")]),_c('meta',{attrs:{"charset":"utf-8"}}),_c('meta',{attrs:{"name":"viewport","content":"width=device-width, initial-scale=1"}})])
}]

export { render, staticRenderFns }